/** fileName: IModal.js
 * developer: majid.garavand@gmail.com
 * created: 3/17/23
 * note: Do not delete this comment to maintain copyright rules
 * */
import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";


const IModal = ({
                    open,
                    handleClose = undefined,
                    headerItems = null,
                    showClose = false,
                    width = 600,
                    height = "auto",
                    borderRadius,
                    top,
                    left,
                    overflow = 'scroll',
                    maxHeight = '90%',
                    maxWidth = '90%',
                    children
                }) => {
    const style = {
        position: 'absolute',
        top: top ? top : '50%',
        left: left ? left : '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        outline: 'none',
        width: width,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        border: 'none !important',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.04)',
        borderRadius: borderRadius ? borderRadius : '20px',
        padding: '4px 12px',
        textAlign: 'center',
        height: height,
        display: 'flex',
        flexDirection: 'column',
    };


    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Grid sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'end',
                    backgroundColor: 'inherit',
                    height: '42px',
                    color: '#9d9a9a',
                    cursor: 'pointer',
                    top: 0,
                    position: 'sticky',
                    zIndex: 322
                }}>
                    {
                        showClose &&
                        <CloseIcon onClick={handleClose} color={'error'}/>
                    }
                    {headerItems}
                </Grid>

                <Grid flexGrow={1} sx={{overflowY: overflow}}>
                    {children}
                </Grid>
            </Box>
        </Modal>
    )
}
export default IModal
